import { Flex, Spinner, Text } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'
import React, { useEffect } from 'react'

import { useAuth } from '@/hooks/useAuth'

const SignOut: React.FC = () => {
  const navigate = useNavigate()
  const { signOut } = useAuth()

  useEffect(() => {
    signOut()
    navigate('/users/sign-in')
  }, [])

  return (
    <Flex flexGrow="1" justify="center">
      <Flex gap="2" p="4">
        <Spinner />
        <Text>Cerrando sesión...</Text>
      </Flex>
    </Flex>
  )
}

export default SignOut
